<template>
  <div class="col-sm-4 card  mb-3 px-0">
    <div class="card-header text-dark">
      <h5 class="card-title"></h5>
    </div>
    <div class="card-body text-center">
      <div class="spinner-grow spinner-grow-sm spinner-bg mr-1" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <div class="spinner-grow spinner-grow-sm spinner-bg mr-1" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <div class="spinner-grow spinner-grow-sm spinner-bg" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <span class="mb-2"></span>
      <p></p>
    </div>
  </div>
</template>

<style scoped>
.profile-image img {
  width: 100%;
  height: auto;
  padding-top: 80%;
  animation: pulse-bg 1s infinite;
}
.card-body span {
  width: 80%;
  margin: 0 auto;
  height: 16px;
  display: block;
  animation: pulse-bg 1s infinite;
}
.card-header {
  width: 100%;
  animation: pulse-bg 1s infinite;
}
.card-body p {
  width: 80%;
  margin: 0 auto;
  height: 30px;
  animation: pulse-bg 1s infinite;
}
.spinner-bg {
  background: #eaeaea;
}
.spinner-grow {
  animation: 1.5s linear infinite spinner-grow;
}

@keyframes pulse-bg {
  0% {
    background-color: #eee;
  }
  50% {
    background-color: #eaeaea;
  }
  100% {
    background-color: #eee;
  }
}
</style>
